const webhook = {
  latest_20_events: "Latest 20 events",
  refresh: "Refresh",
  access_denied: "Access denied",
  no_data_found: "No data found",
  event_id: "Event ID",
  event_type: "Event type",
  status: "Status",
  retry_count: "Retry count",
  date: "Date",
  destination_url: "Destination URL",
  create_date: "Create date",
  message: "Message",
  event_logs: "Event logs",
  attempts: "{{count}} attempts",
  select_an_event_to_view_details: "Select an event to view details",
  time: "Time",
  payload: "Payload",
  copy: "Copy",
  copied: "Copied",
  Pending: "Pending",
  Failed: "Failed",
  Sent: "Sent",
  DocumentApproval: `Document approval`,
  DocumentApproved: `Document approved`,
  DocumentRejected: `Document rejected`,
  DocumentCreated: `Document created`,
  DocumentDeleted: `Document deleted`,
  DocumentProcessed: `Document processed`,
  DocumentReviewed: `Document reviewed`,
};

export default webhook;
